<script setup lang="ts">
  import { ref, watch } from "vue"
  import { GDialog } from 'gitart-vue-dialog'

  type Props = {
    modalState: boolean,
    title: string,
    titleClass: string,
    subTitle: string,
    subTitleClass: string,
    note?: string,
    noteClass: string,
    closeBtnName: string,
    closeBtnClass?: string,
    btnClass?: string,
    modalMaxWidth?: string,
    downloading?: boolean,
  };
  const props = withDefaults(defineProps<Props>(), {
    modalState: false,
    title: 'エラー',
    closeBtnName: '閉じる',
    titleClass: 'alert-modal-title',
    subTitleClass: 'alert-modal-subtitle',
    noteClass: 'alert-modal-note',
  });
  const localModalState = ref(false)

  watch(() => props.modalState, (value) => {
    localModalState.value = value
  })

  const emit = defineEmits(['closeModal'])

  function close() {
    emit("closeModal");
  }
</script>

<style scope>
.alert-modal-title, .alert-modal-subtitle, .alert-modal-note {
  color: red;
}
</style>

<template>
  <GDialog
    v-model="localModalState"
    :max-width="props.modalMaxWidth"
    transition="custom-from-bottom-transition"
    :persistent='true'
  >
    <div class="modal-header justify-content-center mt-2">
      <label :class="props.titleClass">{{ props.title }}</label>
    </div>

    <div class="modal-body mx-4">
      <label :class="props.subTitleClass">{{ props.subTitle }}</label>
      <slot name="supplementary-item" />

      <div :class="props.noteClass">{{ props.note }}</div>
    </div>

    <div class="d-flex justify-content-end m-3 mt-4">
      <v-btn :class="props.closeBtnClass" class="close-btn" @click="close" :disabled="props.downloading">
        {{ props.closeBtnName }}
      </v-btn>
    </div>
  </GDialog>
</template>
